<app-toast></app-toast>
<app-add-missing-data [toast]="toast"></app-add-missing-data>
<div *ngIf="showPopup"
    class="absolute top-1/2 right-1/2 translate-x-1/2 -translate-y-1/2 flex flex-col justify-evenly gap-5 p-5 bg-[#FFFFFF] shadow-sm border-border rounded-[16px] border-[1px] mobile:min-w-[80%]">
    <div class="flex w-full justify-between gap-2 items-center">
        <h1 class="font-bold text-xl mobile:text-base">{{ 'dashboard.complete_your_profile' | transloco }}</h1>
        <button (click)="updateShowPopup(false)" title="{{ 'shared.close' | transloco }}">
            <img src="assets/icons/close-circle-black.svg" alt="X" />
        </button>
    </div>
    <p class="mobile:text-xs">
        {{ 'dashboard.complete_your_profile_desc' | transloco }}
    </p>

    <div class="flex desktop:flex-wrap gap-2 mobile:flex-col w-full">
        <div class="desktop:flex-[1] mobile:w-full min-w-[100px] h-[50px]">
            <app-custom-button buttonText="{{ 'dashboard.add_data' | transloco }}" backgroundColor="bg-primary"
                textColor="text-white" borderColor="border:bg-primary" hoverBackgroundColor="hover:bg-primary-1200"
                fontWeight="font-bold" (buttonClick)="onAddDataClick()"></app-custom-button>
        </div>
        <div class="desktop:flex-[1] mobile:w-full min-w-[100px] h-[50px]">
            <app-custom-button buttonText="{{ 'dashboard.ok_thanks' | transloco }}" backgroundColor="bg-white"
                textColor="text-black" hoverTextColor="hover:text-black" hoverBorderColor="hover:border-border"
                hoverBackgroundColor="hover:bg-neutral-200" borderColor="border-border" (buttonClick)="updateShowPopup(false)"></app-custom-button>
        </div>
    </div>
</div>